(() => {
  function initialize(section) {
    if (section.dataset.returnsInitialized === 'true') return;
    section.dataset.returnsInitialized = 'true';
    const form = section.querySelector('.eb-return-form__form');
    if (!form) return;
    const status = section.querySelector('.eb-return-form__status');
    const orderStatus = section.querySelector('.eb-return-form__order-status');
    const orderField = form.querySelector('[name="order_number"]');
    const emailField = form.querySelector('[name="email"]');
    const productField = form.querySelector('[data-return-product]');
    const quantityField = form.querySelector('[data-return-quantity]');
    const itemsContainer = form.querySelector('[data-return-items]');
    const productsGroup = form.querySelector('[data-return-products]');
    const ibanField = form.querySelector('[name="iban"]');
    const holderField = form.querySelector('[name="account_holder"]');
    let itemRows = [];
    const lookupButton = form.querySelector('[data-order-lookup]');
    const submitButton = form.querySelector('button[type="submit"]');
    let revision = 0;
    let verifiedIdentity = '';
    let controller;
    let submitting = false;

    function identity() {
      return JSON.stringify([orderField.value.trim(), emailField.value.trim().toLowerCase()]);
    }

    function message(target, text, kind = '') {
      target.classList.remove('is-error', 'is-success');
      if (kind) target.classList.add(`is-${kind}`);
      target.textContent = text;
    }

    function resetProducts() {
      verifiedIdentity = '';
      itemRows = [];
      if (ibanField) {
        ibanField.value = ''; holderField.value = '';
        ibanField.disabled = holderField.disabled = true;
        ibanField.required = holderField.required = false;
        form.querySelector('[data-refund-panel]').hidden = true;
        section.querySelector('[data-easybox-content]').hidden = true;
        section.querySelector('[data-delivery-notice]').textContent = 'Verifica mai intai comanda pentru optiunea de transport.';
      }
      if (itemsContainer) {
        itemsContainer.textContent = 'Verifica mai intai comanda.';
        productsGroup.disabled = true;
        return;
      }
      productField.replaceChildren(new Option('Verifica mai intai comanda', ''));
      productField.disabled = true;
      quantityField.value = '1';
      quantityField.max = '1';
      quantityField.disabled = true;
    }

    function showItems(items, order) {
      itemsContainer.replaceChildren();
      itemRows = items.map((item, index) => {
        const row = document.createElement('div'); row.className = 'eb-return-form__product';
        const check = document.createElement('input'); check.type = 'checkbox'; check.id = `return-${section.id || 'items'}-${index}`;
        const visual = document.createElement('span');
        try {
          const url = new URL(item.image);
          if (url.protocol === 'https:' && (url.hostname === 'cdn.shopify.com' || (url.hostname === 'eb-prime.com' && url.pathname.startsWith('/cdn/shop/'))) && !url.username && !url.password) {
            const img = document.createElement('img'); img.src = url.href; img.alt = item.title; img.loading = 'lazy'; visual.appendChild(img);
          }
        } catch (_) { /* A deleted Shopify image has no substitute URL. */ }
        const label = document.createElement('label'); label.htmlFor = check.id; label.textContent = item.title;
        const detail = document.createElement('small'); detail.textContent = `${item.sku ? `SKU ${item.sku} · ` : ''}Disponibil pentru retur: ${item.quantity}`; label.appendChild(detail);
        const quantity = document.createElement('input'); quantity.type = 'number'; quantity.inputMode = 'numeric';
        quantity.min = '1'; quantity.max = String(item.quantity); quantity.value = '1'; quantity.disabled = true;
        quantity.setAttribute('aria-label', `Cantitate: ${item.title}`);
        check.addEventListener('change', () => { quantity.disabled = !check.checked; });
        row.append(check, visual, label, quantity); itemsContainer.appendChild(row);
        return {item, check, quantity};
      });
      productsGroup.disabled = false;
      if (ibanField) {
        const cod = order.payment?.kind === 'COD' && order.payment.ibanRequired === true;
        form.querySelector('[data-refund-panel]').hidden = false;
        form.querySelector('[data-refund-message]').textContent = order.payment?.message || 'Metoda de rambursare va fi verificata de echipa.';
        ibanField.disabled = holderField.disabled = !cod;
        ibanField.required = holderField.required = cod;
        form.querySelector('[data-account-holder]').hidden = !cod;
        const easybox = order.delivery?.kind === 'EASYBOX';
        section.querySelector('[data-easybox-content]').hidden = !easybox;
        section.querySelector('[data-delivery-notice]').textContent = easybox ? 'Comanda livrata la easybox.'
          : order.delivery?.kind === 'COURIER' ? 'Livrare prin curier. Dupa verificarea cererii, echipa te contacteaza pentru organizarea transportului de retur.'
            : 'Echipa va confirma optiunea de transport dupa verificarea cererii.';
      }
    }

    function endpoint(value, fallback) {
      const url = new URL(value || fallback, window.location.origin);
      if (url.origin !== window.location.origin || !url.pathname.startsWith('/apps/retur-eb-prime/')) {
        throw new Error('Serviciul de retur nu este disponibil. Contacteaza contact@eb-prime.com.');
      }
      return url.href;
    }

    async function post(url, data, signal) {
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify(data),
        signal,
      });
      const payload = await response.json().catch(() => null);
      if (!response.ok) {
        throw new Error(typeof payload?.message === 'string' ? payload.message
          : 'Serviciul de retur nu este disponibil momentan. Contacteaza contact@eb-prime.com.');
      }
      if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
        throw new Error('Raspuns invalid. Contacteaza contact@eb-prime.com.');
      }
      return payload;
    }

    const accountOrder = new URLSearchParams(window.location.search).get('order');
    if (accountOrder && !orderField.value) orderField.value = accountOrder;
    resetProducts();
    [orderField, emailField].forEach((field) => field.addEventListener('input', () => {
      revision++;
      controller?.abort();
      lookupButton.disabled = false;
      lookupButton.removeAttribute('aria-busy');
      resetProducts();
      message(orderStatus, '');
      message(status, '');
    }));

    lookupButton.addEventListener('click', async () => {
      if (submitting || lookupButton.disabled) return;
      if (!orderField.value.trim() || !emailField.value.trim() || !emailField.checkValidity()) {
        message(orderStatus, 'Introdu numarul comenzii si adresa de e-mail.', 'error');
        return;
      }
      const requestRevision = ++revision;
      const requestedIdentity = identity();
      controller?.abort();
      controller = new AbortController();
      const requestController = controller;
      const timeout = setTimeout(() => requestController.abort(), 20000);
      lookupButton.disabled = true;
      lookupButton.setAttribute('aria-busy', 'true');
      resetProducts();
      message(status, '');
      message(orderStatus, 'Verificam comanda...');
      try {
        const payload = await post(
          endpoint(section.dataset.orderEndpoint, '/apps/retur-eb-prime/order'),
          {order_number: orderField.value.trim(), email: emailField.value.trim()},
          requestController.signal,
        );
        if (revision !== requestRevision || identity() !== requestedIdentity) return;
        const order = payload.order;
        if (!order || typeof order.name !== 'string' || !Array.isArray(order.items)) {
          throw new Error('Comanda nu a putut fi verificata.');
        }
        const items = order.items.filter((item) => item && typeof item.id === 'string'
          && /^gid:\/\/shopify\/LineItem\/\d+$/.test(item.id)
          && typeof item.title === 'string' && Number.isSafeInteger(item.quantity) && item.quantity > 0);
        if (!items.length) {
          throw new Error('Nu exista produse disponibile pentru o noua cerere de retur.');
        }
        if (itemsContainer) showItems(items, order);
        else {
        productField.replaceChildren(new Option('Alege produsul', ''));
        items.forEach((item) => {
          const option = new Option(`${item.title} - maximum ${item.quantity}`, item.id);
          option.dataset.max = String(item.quantity);
          productField.appendChild(option);
        });
        productField.disabled = false;
        }
        verifiedIdentity = requestedIdentity;
        message(orderStatus, `${order.name} a fost gasita. Selecteaza produsele si cantitatile pentru acelasi retur.`, 'success');
      } catch (error) {
        if (revision !== requestRevision) return;
        message(orderStatus, error.name === 'AbortError'
          ? 'Verificarea a durat prea mult. Incearca din nou.'
          : error.message || 'Comanda nu a putut fi verificata.', 'error');
      } finally {
        clearTimeout(timeout);
        if (revision === requestRevision) {
          lookupButton.disabled = false;
          lookupButton.removeAttribute('aria-busy');
        }
      }
    });

    productField?.addEventListener('change', () => {
      const maximum = Number(productField.selectedOptions[0]?.dataset.max);
      quantityField.disabled = !productField.value || !Number.isSafeInteger(maximum) || maximum < 1;
      quantityField.max = quantityField.disabled ? '1' : String(maximum);
      quantityField.value = '1';
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submitting) return;
      const selected = itemRows.filter((row) => row.check.checked);
      if (identity() !== verifiedIdentity || (itemsContainer ? !selected.length : productField.disabled || !productField.value)) {
        message(orderStatus, 'Verifica comanda si alege produsul returnat.', 'error');
        return;
      }
      const quantities = itemsContainer ? selected.map((row) => row.quantity) : [quantityField];
      if (quantities.some((field) => !Number.isSafeInteger(Number(field.value)) || Number(field.value) < 1 || Number(field.value) > Number(field.max))) {
        message(status, 'Verifica cantitatile produselor selectate.', 'error');
        return;
      }
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      const data = Object.fromEntries(new FormData(form).entries());
      if (itemsContainer) data.items = selected.map((row) => ({id: row.item.id, quantity: Number(row.quantity.value)}));
      const controls = Array.from(form.querySelectorAll('input, select, button'));
      const disabledStates = controls.map((control) => control.disabled);
      const submitController = new AbortController();
      const timeout = setTimeout(() => submitController.abort(), 30000);
      let succeeded = false;
      submitting = true;
      controls.forEach((control) => { control.disabled = true; });
      submitButton.setAttribute('aria-busy', 'true');
      message(status, 'Trimitem cererea de retur...');
      try {
        const payload = await post(endpoint(section.dataset.returnEndpoint, '/apps/retur-eb-prime/requests'),
          data, submitController.signal);
        if (typeof payload.publicId !== 'string' || !/^RET-[A-F0-9]{24}$/.test(payload.publicId)) {
          throw new Error('Nu am primit confirmarea cererii. Contacteaza contact@eb-prime.com inainte de a retrimite.');
        }
        succeeded = true;
        message(status, `Cererea ${payload.publicId} a fost inregistrata si asteapta verificarea echipei.`, 'success');
      } catch (error) {
        message(status, error.name === 'AbortError'
          ? 'Nu am primit confirmarea la timp. Contacteaza contact@eb-prime.com inainte de a retrimite.'
          : error.message || 'Cererea nu a putut fi confirmata. Contacteaza contact@eb-prime.com.', 'error');
      } finally {
        clearTimeout(timeout);
        controls.forEach((control, index) => { control.disabled = disabledStates[index]; });
        submitting = false;
        submitButton.removeAttribute('aria-busy');
        if (succeeded) {
          form.reset();
          resetProducts();
          message(orderStatus, '');
        }
      }
    });
  }
  document.querySelectorAll('.eb-return-form').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.eb-return-form').forEach(initialize);
  });
})();
